"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.poolPromises = exports.startTimerMs = void 0;
const delay_1 = require("./delay");
const startTimerMs = ({ startTime = new Date().getTime(), divider = 1, } = {}) => (endTime = new Date().getTime()) => (endTime - startTime) / divider;
exports.startTimerMs = startTimerMs;
const poolPromises = (intervalMs, maxRequestsPerIntervalIncl, arrayOfPromiseCreators = []) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const results = [];
    while (arrayOfPromiseCreators.length > 0) {
        const current = arrayOfPromiseCreators.splice(0, maxRequestsPerIntervalIncl);
        console.log("pool", results.length, "current", current.length, "remaining", arrayOfPromiseCreators.length, "results", results.length * (((_a = results[results.length - 1]) === null || _a === void 0 ? void 0 : _a.length) || 1));
        const getDeltaMs = exports.startTimerMs();
        const tmpResults = yield Promise.all(current.map((promiseCreator) => promiseCreator()));
        results.push(tmpResults);
        console.log("delta", getDeltaMs() / 1000);
        yield delay_1.delay(intervalMs - getDeltaMs());
    }
    return results.flat();
});
exports.poolPromises = poolPromises;
//# sourceMappingURL=poolPromises.js.map